/* eslint-disable */
import { useCallback, useState } from "react";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Autocomplete,
  Container,
  Button,
  Box,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useSelector } from "react-redux";
import moment from "moment";

import SelectField from "../common/components/SelectField";
import PageLayout from "../common/components/PageLayout";
import { useCatch, useEffectAsync } from "../reactHelper";
import EditAttributesAccordion from "./components/EditAttributesAccordion";
import { useTranslation } from "../common/components/LocalizationProvider";
import SettingsMenu from "./components/SettingsMenu";
import useSettingsStyles from './common/useSettingsStyles';

const CostPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const devices = useSelector((state) => state.devices.items);
  const [item, setItem] = useState({});

  useEffectAsync(async () => {
    if (id) {
      const response = await fetch(`/api/costs/${id}`);
      if (response.ok) {
        setItem(await response.json());
      }
    }
  }, [id]);

  const handleSave = useCatch(async () => {
    if (validate()) {

      // console.log(JSON.stringify({
      //   ...item,
      //   eventTime: moment(item.eventTime).toISOString(),
      //   attributes: {},
      // }))
      const response = await fetch(`/api/costs/${item.id ? item.id : ""}`, {
        method: item.id ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...item,
          eventTime: moment(item.eventTime).toISOString(),
          attributes: {},
        }),
      });

      if (response.ok) {
        navigate(-1);
      } else {
        throw Error(await response.text());
      }
    }
  });

  const validate = () =>
    item && item.name && item.type && item.eventTime && item.price;

  return (
    <PageLayout
      menu={<SettingsMenu />}
      breadcrumbs={["userAdmin", "sharedCosts", "sharedCost"]}
    >
      <Container maxWidth="ls" className={classes.container}>
        {item && (
          <>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" gap={1}>
                  <NewReleasesIcon color="white" />
                  <Typography variant="subtitle1">
                    {t("sharedRequired")}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <Box display="flex" flexDirection="column" gap={3}>
                  {/* Primeira linha - Dispositivo e Nome */}
                  <Box display="flex" gap={2} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                    {/* Dispositivo */}
                    <Box flex={1} minWidth={0}>
                      <SelectField
                        fullWidth
                        value={item.deviceId}
                        emptyValue={null}
                        onChange={(event) => setItem({ ...item, deviceId: event.target.value })}
                        endpoint="/api/devices"
                        label={t("sharedDevice")}
                      />
                    </Box>

                    {/* Nome do Custo */}
                    <Box flex={1} minWidth={0}>
                      <TextField
                        fullWidth
                        value={item.name || ""}
                        onChange={(event) => setItem({ ...item, name: event.target.value })}
                        label={t("sharedName")}
                      />
                    </Box>
                  </Box>

                  {/* Segunda linha - Categoria, Data e Preço */}
                  <Box display="flex" gap={2} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                    {/* Categoria */}
                    <Box flex={1} minWidth={0}>
                      <TextField
                        fullWidth
                        value={item.type || ""}
                        onChange={(event) => setItem({ ...item, type: event.target.value })}
                        label={t("costCategory")}
                      />
                    </Box>

                    {/* Data */}
                    <Box flex={1} minWidth={0}>
                      <TextField
                        fullWidth
                        label={t("costDate")}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        value={moment(item.eventTime).locale("en").format(moment.HTML5_FMT.DATE)}
                        onChange={(event) => setItem({ ...item, eventTime: event.target.value })}
                      />
                    </Box>

                    {/* Preço */}
                    <Box flex={1} minWidth={0}>
                      <TextField
                        fullWidth
                        value={item.price || "0"}
                        onChange={(event) => setItem({ ...item, price: event.target.value })}
                        label={t("sharedPrice")}
                        type="number"
                        inputProps={{ step: "0.01" }}
                      />
                    </Box>
                  </Box>

                  {/* Descrição (ocupando linha completa) */}
                  <Box width="100%">
                    <TextField
                      fullWidth
                      value={item.description || ""}
                      onChange={(event) => setItem({ ...item, description: event.target.value })}
                      label={t("sharedDescription")}
                      multiline
                      rows={3}
                      variant="outlined"
                    />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <EditAttributesAccordion
              attributes={item.attributes}
              setAttributes={(attributes) => setItem({ ...item, attributes })}
              definitions={{}}
            />
          </>
        )}
        <div className={classes.buttons}>
          <Button
            type="button"
            color="primary"
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            {t("sharedCancel")}
          </Button>
          <Button
            type="button"
            color="primary"
            variant="contained"
            onClick={handleSave}
          >
            {t("sharedSave")}
          </Button>
        </div>
      </Container>
    </PageLayout>
  );
};

export default CostPage;